import styled from "@emotion/styled";
import Colors from "styles/colors";
import DesktopHeaderConstants from "/segments/desktop/header/layouts/components/basic-header/constants";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "/constants/vp-sizes";
const HEADER_LOGO_HORIZONTAL_PADDING = `${DesktopHeaderConstants.HEADER_CONTENT_HORIZONTAL_PADDING}px`;
export const StyledDynamicGrid = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  background-color: ${({ backgroundColor })=>Colors[backgroundColor]};
  border-radius: ${({ borderRadius })=>borderRadius};
  padding: ${({ gridPadding })=>gridPadding};

  ${({ alignToLogo })=>alignToLogo && `
    max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px;
    padding-left: ${HEADER_LOGO_HORIZONTAL_PADDING}px;
    padding-right: ${HEADER_LOGO_HORIZONTAL_PADDING}px;
  `}
  .grid-container { 
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(${({ minItemWidth })=>minItemWidth}, 1fr));
    grid-auto-rows: min-content;
    grid-gap: ${({ verticalGap })=>verticalGap} ${({ horizontalGap })=>horizontalGap};
    width: 100%;
  }

  .grid-item {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
